import Injection = EECore.Injection;
import DocumentCentreFavouriteDocuments from "../components/documentCentre/favouriteDocuments";
import DocumentCentreQuickSearch from "../components/documentCentre/quickSearch";
import DocumentCentreAdvancedSearchBar from "../components/documentCentre/advancedSearchBar";
import DocumentSearch from "../components/documentCentre/documentSearch";
import News from "../components/news/news";
import Login from "../components/login/login";
import InstabilityMessages from "../components/instabilityMessages/instabilityMessages";
import ContractList from "../components/corporateSearch/contractList";
import AdsSlideshow from "../components/ads/adsSlideshow";
import UpcomingUnavailability from "../components/upcomingUnavailability/upcomingUnavailability";

@Injection.injectableClass("WidgetComponentLoader")
export default class ComponentsLoader {

  @Injection.injectableProperty("WidgetComponentLoader", EECore.Registrations.NESTEDCOMPONENT_LOADER)
  private nestedComponentLoader: EECore.UI.NestedComponentLoader;

  constructor(nestedComponentLoader: EECore.UI.NestedComponentLoader) {
    this.nestedComponentLoader = nestedComponentLoader;
  }

  load(): void {
    const components = {
      documentcentrefavouritedocuments: DocumentCentreFavouriteDocuments,
      documentcentrequicksearch: DocumentCentreQuickSearch,
      documentcentreadvancedsearchbar: DocumentCentreAdvancedSearchBar,
      documentsearch: DocumentSearch,
      news: News,
      login: Login,
      instabilitymessages: InstabilityMessages,
      contractlist: ContractList,
      adsslideshow: AdsSlideshow,
      upcomingUnavailability: UpcomingUnavailability
    };
    this.nestedComponentLoader.addComponents(components);
  }
}